// @flow
import React from 'react';
import {debounce} from 'lodash';
import {Unveil} from '@homeaway/react-unveil';
import {Link} from '@homeaway/react-localization-components';
import HitExperimentCarousel from './HitExperimentCarousel/HitExperimentCarousel';
import HitExperimentInfo from './HitExperimentInfo/HitExperimentInfo';
// $FlowFixMe
import TripBoardButton from '../TripBoardButton/TripBoardButton';
import {PP_ACCEPTED} from '../../constants/badges';
import {PHOTOCAROUSEL_ADVANCE} from '../../utils/carouselEdapUtils';
import type {HitClickEventData} from '../../utils/hitEdapUtils';
import type {SearchParamsType} from '../../reducers/searchParams';
import type {ListingShape, MouseLeaveShape} from '../Hit/Hit';

import './HitExperiment.less';

type Props = {
    deviceType?: string,
    havId?: string,
    hitIndex: number,
    isGoodBot?: boolean,
    isWithoutAnchor?: boolean,
    listing: ListingShape,
    onHitClick?: (HitClickEventData) => void,
    onMouseEnter?: (listingId: string) => void,
    onMouseLeave?: (MouseLeaveShape) => void,
    page?: number,
    pageSize?: number,
    inputParams: SearchParamsType,
    siteName?: string,
    isMultiUnitHit: boolean
};

const HIT_UNVEIL_THRESHOLD = 100;
const HIT_UNVEIL_MIN_HEIGHT = '256px';

const renderHit = (props: Props) => {
    const {
        onHitClick,
        onMouseEnter,
        onMouseLeave,
        deviceType = '',
        havId = '',
        hitIndex,
        listing,
        page,
        pageSize,
        inputParams,
        siteName = '',
        isMultiUnitHit
    } = props;

    if (!listing) {
        return null;
    }

    const handleMouseEnter = () =>
        onMouseEnter && onMouseEnter(listing.listingId);
    const handleMouseLeave = () =>
        !listing.multiUnitProperty &&
        onMouseLeave &&
        onMouseLeave({listing, hitIndex, page, pageSize});
    const onClick = () =>
        onHitClick &&
        onHitClick({
            listing,
            hitIndex,
            page,
            pageSize,
            inputParams,
            havId,
            deviceType,
            siteName
        });
    const rankedBadges = listing.rankedBadges || [];
    const premierPartnerBadge = rankedBadges.find(
        (badge) => badge.id === PP_ACCEPTED
    );

    return (
        <div
            className="HitExperiment"
            data-wdio="hit"
            role="listitem"
            hit-index={hitIndex}
            onMouseEnter={debounce(handleMouseEnter, 100)}
            onMouseLeave={debounce(handleMouseLeave, 100)}
        >
            <Link href={listing.detailPageUrl}>
                {(localizedUrl) => (
                    <HitExperimentCarousel
                        detailPageUrl={localizedUrl}
                        edapAction={PHOTOCAROUSEL_ADVANCE}
                        images={listing.images || []}
                        onImageClick={onClick}
                        premierPartnerBadge={premierPartnerBadge}
                    />
                )}
            </Link>
            <div className="HitExperiment__tripboardButton">
                <TripBoardButton expandedButton={false} listing={listing} />
            </div>
            <HitExperimentInfo
                onClick={onClick}
                listing={listing}
                hitIndex={hitIndex}
                isMultiUnitHit={isMultiUnitHit}
            />
        </div>
    );
};

const HitExperiment = (props: Props) => {
    // Good Bots (deviceClassification = -25) get Hits with no Unveil
    if (props.isGoodBot) {
        return renderHit(props);
    }

    // Unveil for the masses
    return (
        <Unveil
            threshold={HIT_UNVEIL_THRESHOLD}
            minContainerHeight={HIT_UNVEIL_MIN_HEIGHT}
        >
            {renderHit(props)}
        </Unveil>
    );
};

export default HitExperiment;
